{
  "slug": "what-is-iq",
  "title": "ما هو معدل الذكاء؟",
  "description": "تعلم ماذا يعني معدل الذكاء، وماذا يقيس اختبار معدل الذكاء، والحدود الهامة لدرجات معامل الذكاء.",
  "summary": "معدل الذكاء، اختصارا لنسبة الذكاء، هو علامة موحدة مصممة لوصف الأداء في مهام معرفية مختارة مقارنة بالأشخاص من نفس العمر.",
  "sections": [
    {
      "heading": "ماذا يمثل معدل الذكاء",
      "paragraphs": [
        "إن اختبارات الذكاء الحديثة تجمع بين النتائج التي تسفر عنها مهام مصممة بعناية وتقارنها بمجموعة مرجعية ممثلة. وعادة ما يركز المقياس على 100 نقطة.100)٢( انظر )١(، لذا فإن النتيجة تصف اﻷداء النسبي وليس كمية مطلقة من الذكاء.",
        "إن أفضل طريقة لفهم النتيجة هي أن نعتبرها تقديراً. فمن الممكن أن تؤثر ظروف الاختبار، والصحة، واللغة، والدوافع، والتعرف على أشكال الاختبار، وخطأ القياس العادي، على النتيجة."
      ]
    },
    {
      "heading": "ماذا تقيّم اختبارات الذكاء عادة",
      "paragraphs": [
        "وتقوم البطاريات المهنية باختبار عدة قدرات معرفية بدلا من الاعتماد على نوع واحد من الألغاز."
      ],
      "bullets": [
        "الفهم الشفوي والمعارف المكتسبة",
        "التفكير المرئي المكاني والسائل",
        "الذاكرة العاملة والانتباه",
        "سرعة التجهيز"
      ]
    },
    {
      "heading": "ما لا يقيسه معدل الذكاء",
      "paragraphs": [
        "إن معدل الذكاء لا يسجل بشكل كامل الإبداع، أو الحكم العملي، أو الفضول، أو المهارات العاطفية، أو الدوافع، أو الحكمة، أو المعرفة المتخصصة. فهو لا يستطيع أن يحدد قيمة الشخص أو مستقبله.",
        "إن التقييم الذي يشرف عليه مهني مؤهل هو أكثر ملاءمة للقرارات السريرية أو التعليمية أو القانونية. وينبغي أن تظل النتيجة على غرار اختبار الذكاء على الإنترنت إرشادية."
      ]
    }
  ],
  "faqs": [
    {
      "question": "ماذا تعني كلمة IQ؟",
      "answer": "IQ تعني معامل الذكاء، وهو علامة موحدة تقارن أداء معرفي مختارة مع مجموعة مرجعية قائمة على العمر."
    },
    {
      "question": "هل اختبار الذكاء على الإنترنت تشخيص؟",
      "answer": "لا، النتائج المتاحة على الإنترنت هي تقديرات ولا ينبغي أن تحل محل تقييم يجريه مهني مؤهل."
    }
  ],
  "related": ["how-is-iq-measured", "iq-vs-intelligence", "what-is-the-average-iq"]
}
